import React, { useState } from "react"
import {
	Grid,
	Typography,
	IconButton,
	Box,
	Input
} from "@material-ui/core"
import {
	Search as SearchIcon,
	ChevronLeft as ChevronLeftIcon,
	X as XIcon
} from "lucide-react"

import { useChatGlobalStateStore } from "@/store/ChatGlobalState"

import { colors } from "@/styles/colors"

import InstanceChip from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/InstanceChip"
import useStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/mobileStyles"

const SEARCH_ICON_SIZE_IN_PIXELS = 19
const BACK_ICON_SIZE_IN_PIXELS = 22
const CLEAR_ICON_SIZE_IN_PIXELS = 14

const ChatListHeader: React.FC = () => {
	const classes = useStyles()
	const chatGlobalStateStore = useChatGlobalStateStore()

	const [isSearchExpanded, setIsSearchExpanded] = useState<boolean>(false)

	const searchText = chatGlobalStateStore.chatListPanel.chatListFilter.current.text

	const handleExpandSearch = () => {
		setIsSearchExpanded(true)
	}

	const handleCollapseSearch = () => {
		setIsSearchExpanded(false)
		chatGlobalStateStore.chatListPanel.chatListFilter.update({ text: "" })
	}

	const handleChangeSearch = (value: string) => {
		chatGlobalStateStore.chatListPanel.chatListFilter.update({ text: value })
	}

	const handleClearSearch = () => {
		chatGlobalStateStore.chatListPanel.chatListFilter.update({ text: "" })
	}

	if (isSearchExpanded) {
		return (
			<Grid container>
				<Grid
					item
					xs={12}
				>
					<Box className={classes.expandedHeader}>
						<IconButton
							disableRipple
							onClick={handleCollapseSearch}
							className={classes.backButton}
						>
							<ChevronLeftIcon size={BACK_ICON_SIZE_IN_PIXELS} />
						</IconButton>
						<Box className={classes.searchInputWrapper}>
							<SearchIcon
								size={SEARCH_ICON_SIZE_IN_PIXELS}
								color={colors.gray[500]}
							/>
							<Input
								fullWidth
								disableUnderline
								placeholder="Nome, email e telefone"
								className={classes.searchInput}
								value={searchText}
								onChange={({ target }) => handleChangeSearch(target.value)}
							/>
							{searchText && (
								<IconButton
									disableRipple
									onClick={handleClearSearch}
									className={classes.clearButton}
									size="small"
								>
									<XIcon size={CLEAR_ICON_SIZE_IN_PIXELS} />
								</IconButton>
							)}
						</Box>
					</Box>
				</Grid>
			</Grid>
		)
	}

	return (
		<Grid container>
			<Grid
				item
				xs={12}
			>
				<Box className={classes.collapsedHeader}>
					<Box className={classes.titleGroup}>
						<Typography className={classes.headerTitle}>
							Atendimentos
						</Typography>
						<InstanceChip className={classes.instanceChipAlignment} />
					</Box>
					<IconButton
						disableRipple
						onClick={handleExpandSearch}
						className={classes.searchButton}
					>
						<SearchIcon size={SEARCH_ICON_SIZE_IN_PIXELS} />
					</IconButton>
				</Box>
			</Grid>
		</Grid>
	)
}

export default ChatListHeader
